export default "__VITE_ASSET__DRbHHMtf__"